import { render } from "./offer-item.vue?vue&type=template&id=44fc8918"
import script from "./offer-item.vue?vue&type=script&lang=js"
export * from "./offer-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__